import {bootTargetOf} from './boot-target';

/*
 * The entry: it decides which root to mount and imports that root lazily
 * (04-frontend/architecture.md §5). It imports nothing else, on purpose — any
 * module named here is downloaded by every visit, including a QR scan of the
 * public verifier, which must not pay for the application bundle
 * (pages/passport-verify.md criterion 10; the build asserts it).
 */
const container = document.getElementById('root');

if (container) {
  const {pathname} = window.location;

  if (bootTargetOf(pathname) === 'verifier') {
    void import('./features/passport-verify/boot').then(({mountVerifier}) => {
      mountVerifier(container, pathname);
    });
  } else {
    void import('./app/boot').then(({mountApplication}) => {
      mountApplication(container);
    });
  }
}
